import React from 'react';
import MenuSection from './MenuSection';
import MenuItemSeparator from './MenuItemSeparator';
import MenuItem from './MenuItem';

export default class MenuList extends React.Component {
  // Function to handle mobile sidebar closure
  closeMobileSidebar = () => {
    const isMobile = window.innerWidth < 1025;
    if (isMobile) {
      const closeBtn = document.getElementById('kt_aside_close_btn');
      if (closeBtn) {
        closeBtn.click();
      }
    }
  };

  render() {
    const {
      currentUrl,
      menuConfig,
      layoutConfig,
      currentUser,
      handleClickAccountSettings,
      user,
      isOpenAccountSettings,
    } = this.props;

    return menuConfig.aside.items.map((child, index) => {
      return (
        <React.Fragment key={`menuList${index}`}>
          {child.section && <MenuSection item={child} />}
          {child.separator && <MenuItemSeparator item={child} />}
          {child.title && (
            <MenuItem
              item={child}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
              currentUser={currentUser}
              handleClickAccountSettings={handleClickAccountSettings}
              user={user}
              isOpenAccountSettings={isOpenAccountSettings}
              onClick={this.closeMobileSidebar}
            />
          )}
        </React.Fragment>
      );
    });
  }
}
